/* Small gallery-only play/pause control; native timeline chrome stays disabled. */
(() => {
  if (customElements.get('mf-gallery-video-controls')) return;
  class MFGalleryVideoControls extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      const media = this.parentElement.querySelector('video-media[type="video"]');
      const video = media?.querySelector('video');
      const button = this.querySelector('button');
      if (!video || !button) return;
      video.controls = false;
      const update = () => {
        const paused = video.paused || video.ended;
        button.setAttribute('aria-label', paused ? 'Play product video' : 'Pause product video');
        button.title = paused ? 'Play video' : 'Pause video';
        this.querySelector('[data-play]').toggleAttribute('hidden', !paused);
        this.querySelector('[data-pause]').toggleAttribute('hidden', paused);
      };
      button.addEventListener('click', () => {
        // Use the theme media controller so loaded/playing state and groups stay intact.
        if (video.paused || video.ended) media.play();
        else media.pause();
      }, options);
      for (const event of ['play','pause','ended','loadedmetadata']) video.addEventListener(event, update, options);
      update();
      this.hidden = false;
    }
    disconnectedCallback() { this.abort?.abort(); }
  }
  customElements.define('mf-gallery-video-controls', MFGalleryVideoControls);
})();
